import React from 'react';

import { ARIA_TITLE_ID } from '@components/CookieBanner/shared/utils';

import styles from './cookieBannerPanelTitle.scss';

interface TitleProps {
  children: React.ReactNode;
}

const Title = ({ children }: TitleProps) => (
  <h2
    className={styles.title}
    id={ARIA_TITLE_ID}
    // eslint-disable-next-line react/no-danger
    dangerouslySetInnerHTML={{ __html: children }}
  />
);

export default Title;
